import axios from "axios";
import { InvoiceDetails, PaginatedResponse, ResellerStats, Invoice, Key } from "./types";

export interface ResellerActivationItem {
    target_plan: 'monthly' | 'lifetime';
    target_package: 'basic' | 'advanced';
    quantity: number;
}

export interface ResellerActivationResponse {
    invoice_id: number;
    order_id: string;
    amount: string;
    items: ResellerActivationItem[];
    discount_percent: number;
}

export interface ResellerStorefront {
    name: string;
    slug: string;
}

export interface ResellerKeysResponse {
    values: Key[];
    total: number;
    remaining: number;
}

export const reseller = {
    getStats() {
        return axios.get<ResellerStats>('reseller');
    },
    getInvoices(limit = 50, page = 0) {
        return axios.get<PaginatedResponse<Invoice>>(`reseller/invoices?limit=${limit}&page=${page}`);
    },
    getInvoice(id: number) {
        return axios.get<InvoiceDetails>(`reseller/invoices/${id}`);
    },
    deleteInvoice(id: number) {
        return axios.delete(`reseller/invoices/${id}`);
    },
    activate(reseller_name: string) {
        return axios.post<ResellerActivationResponse>('reseller/activate', { reseller_name });
    },
    getKeys(params: { status?: string; type?: string; plan?: string; limit?: number; page?: number } = {}) {
        return axios.get<ResellerKeysResponse>('reseller/keys', { params });
    },
    exportKeys(params: { type?: string; plan?: string } = {}) {
        return axios.get<{ keys: string[]; count: number }>('reseller/keys/export', { params });
    },
    getStorefront(slug: string) {
        return axios.get<ResellerStorefront>(`reseller/storefront/${encodeURIComponent(slug)}`);
    },
};
